import {
  IconAirConditioningOutline,
  IconArchiveOutline,
  IconBankOutline,
  IconBlueprintFilled,
  IconBuildingOutline,
  IconCalendarFilled,
  IconCameraFilled,
  IconChecklistFilled,
  IconDollarSignCircleFilled,
  IconDollarSignCircleOutline,
  IconEditFilled,
  IconEditFormOutline,
  IconFileFilled,
  IconFileOutline,
  IconHammerOutline,
  IconHandshakeFilled,
  IconHOAOutline,
  IconHomeCompareFilled,
  IconHomeTypeFilled,
  IconHouseFilled,
  IconKeyFilled,
  IconLaundryFilled,
  IconLaundryOutline,
  IconLightBulbOutline,
  IconMonitorOutline,
  IconParkingOutline,
  IconPetsFilled,
  IconPetsOutline,
  IconPhoneFilled,
  IconTaxOutline,
  IconTourDoorFilled,
  IconUnconstrainedFlyOverFilled,
  IconUserAddFilled,
  IconUserGroupOutline,
  IconUserOutline,
  IconWarningOutline,
  IconYardSignFilled,
} from '@zillow/constellation-icons';

const getIconByName = ({ name, useFallbackIcon }: { name: string; useFallbackIcon?: boolean }) => {
  let IconComponent = null;

  switch (name) {
    case 'DetailedIconAddUser':
    case 'IconUserAddFilled':
      IconComponent = IconUserAddFilled;
      break;
    case 'DetailedIconBlueprint':
    case 'IconBlueprintFilled':
      IconComponent = IconBlueprintFilled;
      break;
    case 'DetailedIconCalendar':
    case 'IconCalendarFilled':
      IconComponent = IconCalendarFilled;
      break;
    case 'DetailedIconCamera':
    case 'IconCameraFilled':
      IconComponent = IconCameraFilled;
      break;
    case 'DetailedIconChecklist':
    case 'IconChecklistFilled':
      IconComponent = IconChecklistFilled;
      break;
    case 'DetailedIconCompare':
    case 'IconHomeCompareFilled':
      IconComponent = IconHomeCompareFilled;
      break;
    case 'DetailedIconDollarHome':
    case 'IconDollarCircleFilled':
      IconComponent = IconHouseFilled;
      break;
    case 'DetailedIconFile':
    case 'IconFileFilled':
      IconComponent = IconFileFilled;
      break;
    case 'DetailedIconForSaleSign':
    case 'IconYardSignFilled':
      IconComponent = IconYardSignFilled;
      break;
    case 'DetailedIconHandshake':
    case 'IconHandshakeFilled':
      IconComponent = IconHandshakeFilled;
      break;
    case 'DetailedIconHome':
    case 'IconHouseFilled':
      IconComponent = IconHouseFilled;
      break;
    case 'DetailedIconHomeTour':
    case 'IconTourDoorFilled':
      IconComponent = IconTourDoorFilled; // v8 DetailedIconHomeTour → v10 IconTourDoorFilled
      break;
    case 'DetailedIconKeyHome':
    case 'IconKeyFilled':
      IconComponent = IconKeyFilled; // v8 DetailedIconKeyHome → v10 IconKeyFilled
      break;
    case 'DetailedIconLaundry':
    case 'IconLaundryFilled':
      IconComponent = IconLaundryFilled;
      break;
    case 'DetailedIconPiggybank':
    case 'IconPiggybankFilled':
      IconComponent = IconDollarSignCircleFilled;
      break;
    case 'DetailedIconStarRising':
    case 'IconStarFilled':
      IconComponent = IconTourDoorFilled; // IconStarFilled doesn't exist in v10, using IconTourDoorFilled as fallback
      break;
    case 'DetailedIconNewConstruction':
    case 'IconHomeTypeFilled':
      IconComponent = IconHomeTypeFilled;
      break;
    case 'DetailedIconPencilDollar':
    case 'IconEditFilled':
      IconComponent = IconEditFilled;
      break;
    case 'DetailedIconPet':
    case 'IconPetsFilled':
      IconComponent = IconPetsFilled; // v8 DetailedIconPet → v10 IconPetsFilled
      break;
    case 'DetailedIconPhone':
    case 'IconPhoneFilled':
      IconComponent = IconPhoneFilled;
      break;
    case 'DetailedIconVirtualTour':
    case 'IconUnconstrainedFlyOverFilled':
      IconComponent = IconUnconstrainedFlyOverFilled;
      break;
    case 'IconLaundryOutline':
      IconComponent = IconLaundryOutline;
      break;
    case 'IconTeamOutline':
      IconComponent = IconUserGroupOutline; // v8 IconTeamOutline → v10 IconUserGroupOutline
      break;
    case 'IconFileOutline':
      IconComponent = IconFileOutline;
      break;
    case 'IconEditFormOutline':
      IconComponent = IconEditFormOutline;
      break;
    case 'IconDollarSignCircleOutline':
      IconComponent = IconDollarSignCircleOutline;
      break;
    case 'IconParkingOutline':
      IconComponent = IconParkingOutline;
      break;
    case 'IconTaxOutline':
      IconComponent = IconTaxOutline;
      break;
    case 'IconPetsOutline':
      IconComponent = IconPetsOutline;
      break;
    case 'IconBankOutline':
      IconComponent = IconBankOutline;
      break;
    case 'IconHOAOutline':
      IconComponent = IconHOAOutline;
      break;
    case 'IconArchiveOutline':
      IconComponent = IconArchiveOutline;
      break;
    case 'IconMonitorOutline':
      IconComponent = IconMonitorOutline;
      break;
    case 'IconBulbOutline':
      IconComponent = IconLightBulbOutline; // v8 IconBulbOutline → v10 IconLightBulbOutline
      break;
    case 'IconHammerOutline':
      IconComponent = IconHammerOutline;
      break;
    case 'IconProfileOutline':
      IconComponent = IconUserOutline; // v8 IconProfileOutline → v10 IconUserOutline
      break;
    case 'IconWarningOutline':
      IconComponent = IconWarningOutline;
      break;
    case 'IconAirConditioningOutline':
      IconComponent = IconAirConditioningOutline;
      break;
    default:
      return useFallbackIcon ? IconBuildingOutline : null;
  }

  return IconComponent;
};

export { getIconByName };
